var N = Object.defineProperty, T = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
var c = (o, r, i) => r in o ? N(o, r, { enumerable: !0, configurable: !0, writable: !0, value: i }) : o[r] = i, t = (o, r) => {
  for (var i in r || (r = {}))
    f.call(r, i) && c(o, i, r[i]);
  if (m)
    for (var i of m(r))
      a.call(r, i) && c(o, i, r[i]);
  return o;
}, I = (o, r) => T(o, z(r));
var l = (o, r) => {
  var i = {};
  for (var e in o)
    f.call(o, e) && r.indexOf(e) < 0 && (i[e] = o[e]);
  if (o != null && m)
    for (var e of m(o))
      r.indexOf(e) < 0 && a.call(o, e) && (i[e] = o[e]);
  return i;
};
import { jsx as d } from "react/jsx-runtime";
import P from "icomoon-react";
import s from "../../../node_modules/prop-types/index.es.js";
import R from "react";
import S from "./selection.json.es.js";
import * as g from "./style.es.js";
import { Icon as j } from "./style.es.js";
import { ICON_COMPONENT_SIZE as y } from "../../../constants/sizes.es.js";
const n = R.forwardRef((x, O) => {
  var p = x, {
    color: o,
    size: r = y.md,
    name: i
  } = p, e = l(p, [
    "color",
    "size",
    "name"
  ]);
  return /* @__PURE__ */ d(j, I(t({ color: o, $size: r, ref: O }, e), { children: /* @__PURE__ */ d(P, t({ iconSet: S, size: "100%", icon: i, title: "" }, e)) }));
}), u = {
  color: s.string,
  name: s.string.isRequired,
  size: s.oneOf(Object.values(y))
};
n.S = g;
n.propTypes = u;
n.displayName = "Icon";
export {
  n as Icon,
  u as iconPropTypes
};
//# sourceMappingURL=Icon.es.js.map
